// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.foxwallet",
    name: "FoxWallet",
    homepage: "http://foxwallet.com",
    image_id: "d673068d-1acf-4372-76ee-8eb931c59e00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/app/foxwallet-crypto-web3/id1590983231",
        android: "https://play.google.com/store/apps/details?id=com.foxwallet.play",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "foxwallet://",
        universal: "https://link.foxwallet.com",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map